<template>
	<div class="espectaculos">
		<div class="espectaculos-header">
			<div class="img-header">
				<img src="https://cnf-s3-bucket.s3.us-east-1.amazonaws.com/paseo-gpc.svg" alt="Paseo del GPC">
			</div>
			<div class="container">
				<h1>Paseo del Gran Parque Central</h1>
				<p>A continuación se listan todas las fechas disponibles para que vengas a conocer el Parque</p>
			</div>
		</div>
		<div class="espectaculos-main">
			<div class="container">
				<div class="lista-espectaculos">
					<div class="espectaculos-list" v-if="cargandoEspectaculos">
						<vcl-facebook style="margin-right: 20px;"></vcl-facebook>
						<vcl-facebook style="margin-right: 10px;margin-left: 10px;"></vcl-facebook>
						<vcl-facebook style="margin-left: 20px;"></vcl-facebook>
					</div>
					<div class="espectaculos-list" v-if="!cargandoEspectaculos && espectaculos.length > 0">
						<a v-for="(espectaculo, index) in espectaculos" :key="espectaculo.id" @click="irAEspectaculo(espectaculo.EspectaculoId, index)" class="item" :class="{ 'item-agotado': espectaculo.EspectaculoAgotado }">
							<div class="paseo-fecha">
								<span class="fecha">{{ espectaculo.EspectaculoFechaEscritaShort }}</span>
								<span class="hora">{{ espectaculo.EspectaculoHora }}</span>
								<span class="span-agotado" v-if="espectaculo.EspectaculoAgotado">
									Localidades agotadas
								</span>
							</div>
							<button>
								Canjear entradas
							</button>
						</a>
						<!-- <div class="espectaculo-wrapper" v-for="(espectaculo, index) in espectaculos" :key="espectaculo.id">
							<a @click="irAEspectaculo(espectaculo.EspectaculoId, index)" class="espectaculo espectaculo-paseo" :class="{ 'espectaculo-agotado': espectaculo.EspectaculoAgotado }">
								<div class="espectaculo-agotado-overlay" v-if="espectaculo.EspectaculoAgotado">
									<span>Localidades agotadas</span>
								</div>
								<div class="espectaculo-tipo" :style="{ 'background-color' : '#' + espectaculo.EspectaculoTipoColor }">
									{{ espectaculo.EspectaculoTipoNombre }}
								</div>
								<div class="paseo-top">
									<img src="https://cnf-s3-bucket.s3.us-east-1.amazonaws.com/paseo-gpc.svg" alt="Paseo del GPC">
								</div>
								<div class="paseo-fecha">
									<span class="fecha">{{ espectaculo.EspectaculoFechaEscritaShort }}</span>
									<span class="hora">{{ espectaculo.EspectaculoHora }}</span>
								</div>
								<div class="paseo-footer">
									<img src="https://cnf-s3-bucket.s3.us-east-1.amazonaws.com/paseo-gpc-footer.svg" alt="Paseo del GPC">
								</div>
								<div class="espectaculo-bottom">
									<div class="espectaculo-bottom-right"></div>
								</div>
							</a>
						</div> -->
					</div>
					<div class="espectaculos-row" v-else>
						<span class="no-espectaculos">Actualmente no hay paseos disponibles</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import { VclFacebook } from 'vue-content-loading';
	// import { FrownIcon } from 'vue-feather-icons'
	
	export default{
		data(){
			return {
				fechaActual: new Date(),
				espectaculos: [],
				cargandoEspectaculos: false
			}
		},
		components: {
			VclFacebook,
			// FrownIcon
		},
		async mounted(){
			this.$store.dispatch('cargando', true);
			this.cargandoEspectaculos = true;
			await this.cargoEspectaculos();
			this.$store.dispatch('cargando', false);
		},
		methods: {
			irAEspectaculo(id, index){
				if(this.espectaculos[index].EspectaculoAgotado === true){
					this.$store.dispatch('mostrarError', '¡Localidades agotadas!')
				} else {
					this.$router.push({ name: 'espectaculo', params: { espectaculoId: parseInt(id) } })
				}
			},
			async cargoEspectaculos(){
				// Obtengo los espectáculos del inicio
				try {
					let response = await axios.post('/WSEspectaculosPaseo', {});

					if(response.data.ErrorCod === 0){
						if(response.data.SDTEspectaculos.length > 0){
							this.espectaculos = response.data.SDTEspectaculos;

							for(var i=0; i<this.espectaculos.length; i++){
								var fecha = new Date(this.espectaculos[i].EspectaculoFecha);
								this.espectaculos[i].EspectaculoFecha = fecha;
							}
						} else {
							this.espectaculos = [];
						}
					}
	
					this.cargandoEspectaculos =  false
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			}
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
	// Multiselects
	.multiselect {
		min-height: 44px;
		width: 100%;
		cursor: pointer;
		transition: all 0.2s;

		&:hover .multiselect__tags {
			transition: all 0.2s;
			border-color: var(--color-blue);
		}
	}

	.multiselect__input,
	.multiselect__single {
		margin: 0;
		font-size: 16px;
		line-height: 25px;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
		padding-left: 0;
	}

	.multiselect__tags {
		border-radius: 0px;
		font-size: 16px;
		line-height: 25px;
		border: none;
		border-bottom: 1px solid var(--color-grey-light);
		display: block;
		width: 100%;
		height: 100%;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
		padding-top: 8px;
		padding-bottom: 10px;
		padding-left: 0px;
		padding-right: 40px;
		outline: none;
		background-color: var(--color-white);
	}

	.multiselect__option--highlight {
		background-color: var(--color-grey-lighter);
		color: var(--color-black);
	}

	.multiselect__option--selected.multiselect__option--highlight {
		background-color: var(--color-red);
		// border-left: 2px solid var(--color-blue-dark);
		color: var(--color-white);
	}

	.multiselect__option {
		font-size: 13px;
		line-height: 13px;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
	}

	.multiselect__option--selected {
		background-color: var(--color-blue);
		color: var(--color-white);
		font-size: 13px;
		line-height: 13px;
	}

	.multiselect__option--highlight:after {
		background: transparent;
		color: #999;
		font-size: 12px;
		font-weight: 300;
	}

	.multiselect__option--selected.multiselect__option--highlight:after,
	.multiselect__option--selected:after {
		background: transparent;
		color: var(--color-white);
		font-size: 12px;
		font-weight: 300;
	}

	.multiselect__tag {
		margin-bottom: 3px !important;
		margin-right: 8px !important;
		background: var(--color-blue) !important;
	}

	.multiselect__tag-icon:after {
		color: var(--color-white) !important;
	}

	.multiselect__tag-icon:focus,
	.multiselect__tag-icon:hover {
		background: none !important;
	}

	.multiselect__placeholder {
		padding-top: 0px;
		margin-bottom: 0px;
	}
</style>

<style lang="scss" scoped>
	.espectaculos{
		min-height: var(--height-page);
		// background-color: var(--color-grey-lighter);
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;
		@include flex(column, flex-start, center);

		.espectaculos-header{
			background-color: var(--color-white);
			padding-top: 72px;
			width: 100%;
			position: relative;
			@include flex(column, flex-start, center);

			.img-header{
				width: 100%;
				padding: 20px 0px;
				@include flex(row, center, center);

				img{
					width: 300px;
					height: auto;
				}
			}

			.container{
				@include flex(column, center, center);
				padding: 20px 0;

				h1{
					margin: 0;
					color: var(--color-red);
					font-weight: initial;
					font-size: 48px;
					line-height: 46px;
					font-family: var(--font-family-kapra-bold);
					text-transform: uppercase;
					text-align: center;
				}

				p{
					margin: 0;
					margin-top: 4px;
					font-size: 18px;
					line-height: 26px;
					font-family: var(--font-family-fira);
					font-weight: bold;
					color: var(--color-dark);
					text-align: center;
				}
			}
		}

		.container{
			height: 100%;
			margin: 0;
			width: 100%;
			max-width: 1260px;
		}

		.espectaculos-main{
			width: 100%;
			margin-top: 0;
			@include flex(row, center, flex-start);
			
			.container{
				max-width: 800px;
				@include flex(column, flex-start, flex-start);

				.no-espectaculos{
					width: 100%;
					@include flex(row, center, center);
					margin-top: 30px;
					background-color: #f3f3f9;
					border-radius: 4px;
					line-height: 1.3em;
					padding: 15px;
					font-family: var(--font-family-fira);
					font-size: 13px;

					svg{
						line-height: 1em;
						width: 16px;
						height: 16px;
						margin-left: 5px;
					}
				}

				.lista-espectaculos{
					width: 100%;
					margin: 10px 0;
					
					.espectaculos-list{
						@include flex(column, flex-start, center);
						width: 100%;
						margin: 0;
						margin-bottom: 30px;
						margin-top: 10px;

						& > svg{
							width: 390px;
						}

						.item{
							width: 100%;
							@include flex(row, space-between, center);
							padding: 15px 18px;
							border-left: 6px solid var(--color-red);
							cursor: pointer;
							box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.07);
							margin: 0;
							margin-bottom: 20px;
							transition: all .2s;
							text-decoration: none;

							&.item-agotado{
								cursor: not-allowed;
								background-color: var(--color-grey-light);
								border-left-color: var(--color-grey);

								button{
									background-color: var(--color-grey-medium);
									color: var(--color-dark);

									&:hover{
										background-color: var(--color-grey-medium);
										color: var(--color-dark);
									}
								}
							}

							.paseo-fecha{
								@include flex(row, flex-start, center);

								.fecha{
									color: var(--color-dark);
									font-size: 20px;
									font-family: var(--font-family-fira);
									font-weight: var(--font-weight-bold);
									text-transform: uppercase;
								}

								.hora{
									color: var(--color-dark);
									font-size: 17px;
									padding-left: 10px;
									border-left: 1px solid var(--color-blue-dark);
									margin-left: 10px;
									font-family: var(--font-family-fira);
									font-weight: var(--font-weight-bold);
								}

								.span-agotado{
									margin-left: 20px;
									color: var(--color-dark);
									font-size: 10px;
									font-family: var(--font-family-poppins);
									font-weight: var(--font-weight-bold);
									text-transform: uppercase;
									border: 1px solid var(--color-grey);
									border-radius: 99px;
									padding: 3px 8px;
									text-align: center;
								}
							}

							button{
								@include flex(row, center, center);
								text-transform: uppercase;
								font-family: var(--font-family-poppins);
								font-weight: var(--font-weight-bold);
								position: relative;
								cursor: pointer;
								background-color: var(--color-blue);
								color: var(--color-white);
								-webkit-transition: background-color .2s ease;
								transition: background-color .2s ease;
								-webkit-letter-spacing: 1px;
								-moz-letter-spacing: 1px;
								-ms-letter-spacing: 1px;
								letter-spacing: 1px;
								padding: 10px 14px;
								font-size: 12px;
								line-height: 16px;
								-webkit-font-smoothing: antialiased;
								-moz-osx-font-smoothing: grayscale;
								outline-color: transparent;
								outline: none;
								box-shadow: none;
								border: none;
								margin: 0;

								-webkit-touch-callout: none;
								-webkit-user-select: none;
								-khtml-user-select: none;
								-moz-user-select: none;
								-ms-user-select: none;
								user-select: none;

								&:hover{
									background-color: var(--color-red);
								}
							}
						}

						

						.espectaculo{
							width: 100%;
							min-height: 286px;
							border-radius: 0px;
							padding: 25px;
							padding-bottom: 35px;
							position: relative;
							cursor: pointer;
							box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.07);
							margin: 0;
							transition: all .2s;
							text-decoration: none;
							display: flex;
							flex-direction: column;
							justify-content: space-evenly;

							&.espectaculo-agotado{
								.espectaculo-tipo{
									background-color: var(--color-grey-medium) !important;
									color: var(--color-grey);
								}

								.espectaculo-bottom{
									background-color: var(--color-grey-light);

									.espectaculo-bottom-right{
										background-color: var(--color-grey-lighter);
									}
								}

								.espectaculo-agotado-overlay{
									position: absolute;
									top: 0;
									left: 0;
									width: 100%;
									height: 100%;
									@include flex(column, center, center);
									background-color: rgba(255, 255, 255, 0.8);

									span{
										color: var(--color-white);
										font-weight: var(--font-weight-bold);
										font-size: 17px;
										font-family: var(--font-family-poppins);
										padding: 8px 10px;
										text-transform: uppercase;
										background-color: var(--color-red);
										transform: rotate(-20deg);
										-webkit-transform: rotate(-20deg);
									}
								}
							}

							.espectaculo-tipo{
								position: absolute;
								left: 50%;
								transform: translateX(-50%);
								top: -9px;
								border-radius: 44px;
								padding: 3px 12px;
								background-color: var(--color-red);
								color: var(--color-white);
								font-size: 10px;
								line-height: 1.3em;
								text-transform: uppercase;
								font-family: var(--font-family-poppins);
							}

							.espectaculo-top{
								display: flex;
								flex-direction: row;
								justify-content: space-around;
								align-items: flex-start;
								margin: 0;
								padding: 0;
								padding-bottom: 25px;

								.espectaculo-miniatura{
									height: 80px;
									margin-bottom: -35px;
								}
							}

							&:hover{
								box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.12);
							}

							.espectaculo-bottom{
								width: 100%;
								border-radius: 0px 0px 12px 12px;
								background-color: var(--color-blue);
								height: 10px;
								position: absolute;
								bottom: 0;
								left: 0;
								padding: 0 20px;
								margin: 0;

								.espectaculo-bottom-right{
									width: 50%;
									background-color: var(--color-blue);
									border-radius: 0px 0px 12px 0px;
									height: 10px;
									position: absolute;
									bottom: 0;
									right: 0;
									padding: 0 20px;
									margin: 0;
								}
							}

							.titulo{
								font-family: var(--font-family-poppins);
								font-weight: var(--font-weight-bold);
								color: var(--color-white);
								font-size: 28px;
								line-height: 1.4em;
								text-align: center;
								width: 100%;
								text-transform: uppercase;
							}

							.espectaculo-bottom{
								width: 100%;
								background-color: var(--color-blue-dark);
								height: 10px;
								border-radius: 0px;
								position: absolute;
								bottom: 0;
								left: 0;
								padding: 0 20px;
								margin: 0;
							}

							.espectaculo-bottom-right{
								width: 50%;
								background-color: var(--color-red);
								height: 10px;
								border-radius: 0px;
								position: absolute;
								bottom: 0;
								right: 0;
								padding: 0 20px;
								margin: 0;
							}

							&.espectaculo-paseo{
								padding-bottom: 25px;

								@include flex(column, space-between, center);

								.paseo-top{
									width: 100%;
									@include flex(column, flex-start, center);

									img{
										margin-bottom: 10px;
										width: 80%;
										height: auto;
									}
								}

								.paseo-fecha{
									width: 100%;
									@include flex(row, center, center);

									.fecha{
										color: var(--color-blue-dark);
										font-size: 24px;
										font-family: var(--font-family-poppins);
										font-weight: var(--font-weight-bold);
										text-transform: uppercase;
									}

									.hora{
										color: var(--color-blue-dark);
										font-size: 20px;
										padding-left: 10px;
										border-left: 1px solid var(--color-blue-dark);
										margin-left: 10px;
										font-family: var(--font-family-poppins);
										font-weight: var(--font-weight-bold);
									}
								}

								.paseo-footer{
									width: 100%;
									@include flex(column, flex-end, center);

									img{
										margin-top: 10px;
										width: 80%;
										height: auto;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	/* Responsive */
	@media screen and (max-width: 1308px){
		.espectaculos{
			.espectaculos-header{
				.container{
					padding-left: 24px;
					padding-right: 24px;
				}
			}

			.espectaculos-main{
				.container{
					padding-left: 24px;
					padding-right: 24px;
				}
			}
		}
	}

	@media screen and (max-width: 1164px){
		.espectaculos{
			.espectaculos-main{
				.container{
					.lista-espectaculos{
						.espectaculos-row{
							@include flex(row, space-between, center);

							.espectaculo-wrapper{
								width: calc(50% - 15px);

								&:nth-child(3n - 2){
									margin-right: 0px;
								}

								&:nth-child(3n - 1){
									margin-left: 0px;
									margin-right: 0px;
								}

								&:nth-child(3n){
									margin-left: 0px;
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 790px){
		.espectaculos{
			.espectaculos-main{
				.container{
					.lista-espectaculos{
						.espectaculos-row{
							.espectaculo-wrapper{
								width: 100%;
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 500px){
		.espectaculos{
			.espectaculos-header{
				.container{
					h1{
						font-size: 26px;
					}

					p{
						font-size: 15px;
						line-height: 18px;
					}
				}
			}

			.espectaculos-main{
				.container{
					.lista-espectaculos{
						.espectaculos-list{
							.item {
								margin-bottom: 15px;

								.paseo-fecha{
									.fecha{
										font-size: 16px;
									}

									.hora{
										font-size: 14px;
									}
								}

								button{
									font-size: 11px;
									padding: 8px 10px;
								}

								&.item-agotado{
									button{
										display: none;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 460px){
		.espectaculos{
			.espectaculos-main{
				.container{
					.lista-espectaculos{
						.espectaculos-row{
							.espectaculo {
								min-height: auto;
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 400px){
		.espectaculos{
			.espectaculos-main{
				.container{
					.lista-espectaculos{
						.espectaculos-row{
							.espectaculo {
								.espectaculo-tipo{
									text-align: center;
								}
							}
						}
					}
				}
			}
		}
	}
</style>